import { useHistory } from 'react-router-dom';
import logo from '../../assets/upgrade-images/logo.svg'
import mobile_logo from '../../assets/upgrade-images/mobile_logo.svg'
import { useMemo } from 'react';
import EntrepreneurHeader from '../headers/entrepreneurHeader';
import PopUpComponent from '../popup';

const PublicLayout = ({ children, redirectTo }) => {
  const history = useHistory();

  const handleRedirectTo = () => {
    if (redirectTo) {
      history.push(redirectTo)
    }
  }

  const hasEntrepreneurial = useMemo(() => {
    const pathname = history?.location?.pathname || "";

    // Pages where it should be false
    // const excludedPaths = ["auth-gateway", "forgot-password"];

    return pathname.includes("entrepreneur") || pathname === "/" || pathname.includes("creighton")
    //  && !excludedPaths.some(path => pathname.includes(path));
  }, [history?.location?.pathname]);

  return (
    <div className="min-h-screen flex flex-col dark:bg-gray-900 page-layout">
      <header className={`w-full fixed top-0 z-20 bg-white shadow dark:shadow-gray-400 transition-all duration-300 ${hasEntrepreneurial ? '' : 'h-20'}`}>
        {
          hasEntrepreneurial ? <EntrepreneurHeader homeURL={redirectTo} /> : <CensioHeader handleRedirectTo={handleRedirectTo} />
        }
      </header>

      <div className={`flex flex-1 ${hasEntrepreneurial ? 'pt-[128px] lg:pt-[75px]' : 'pt-20'} h-full`}>
        <main className={`flex-1 min-h-80 shadow-md shadow-gray-400 overflow-y-auto dark:bg-[#F5F8FE] ${hasEntrepreneurial ? 'h-[calc(100vh-128px)] lg:h-[calc(100vh-75px)]' : 'h-[calc(100vh-5rem)]'} scrollbar`}>
          {children}
        </main>
      </div>
      <PopUpComponent />
    </div>

  );
}

export default PublicLayout;


const CensioHeader = ({ handleRedirectTo = () => { } }) => {

  return (
    <div className="mx-auto h-20 flex justify-between items-center max-w-[calc(100vw-20rem)]">
      <div className="w-full flex justify-between items-center">
        <div className="logo flex items-center gap-2">
          <button className="" onClick={handleRedirectTo}>
            <img className="hidden md:block" loading="lazy" src={logo} alt="" />
            <img className="md:hidden" loading="lazy" src={mobile_logo} alt="" />
          </button>
        </div>
      </div>
      <div>

      </div>
    </div>
  )
}
